<template>
  <div
    v-if="structuredBottomDescription && !isServerRenderedPage"
    :style="{
      background: `url(${bottomCoverImage ? bottomCoverImage : require('../../assets/icons/bg-seo.jpg')})`,
      backgroundSize: 'cover'
    }"
  >
    <div class="container mx-auto py-16" :class="`text-${structuredBottomDescription.textColor}`">
      <div v-if="structuredBottomDescription.title" class="sky__category-description-title" v-html="structuredBottomDescription.title" />
      <div
        class="sky__category-description"
        v-html="structuredBottomDescription.content"
      />
    </div>
  </div>
</template>

<script>
import { marked } from 'marked'
export default {
  props: {
    category: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      isServerRenderedPage: !!this.$route.query.page
    }
  },
  computed: {
    bottomDescription () {
      const description = this.category.properties.bottom_description

      if (!description) {
        return null
      }

      return marked(description)
    },
    bottomCoverImage () {
      if (!this.category.properties.bottom_cover) {
        return undefined
      }
      return this.category.properties.bottom_cover + '?resize=true&width=1500&format=webp'
    },
    structuredBottomDescription () {
      if (!this.bottomDescription) {
        return null
      }
      const titleMatch = this.bottomDescription.match(/<h2.*<\/h2>/)
      if (titleMatch) {
        return {
          title: titleMatch[0],
          content: this.bottomDescription.replace(titleMatch[0], ''),
          textColor: this.category.properties.bottom_cover_is_dark ? 'white' : 'sky_blue'
        }
      }
      return {
        title: null,
        content: this.bottomDescription,
        textColor: this.category.properties.bottom_cover_is_dark ? 'white' : 'sky_blue'
      }
    }
  }
}
</script>

<style lang="scss">
.sky__category-description {
  @apply py-10 px-4;
  @screen lg {
    @apply mx-auto;
    column-count: 2;
    column-gap: 50px;
    max-width: 900px;
  }
  h2 {
    @apply font-funny text-3xl mb-3 text-center;
    line-height: 3rem;
    @screen lg {
      @apply text-5xl;
    }
  }
  h3 {
    @apply font-bold mb-2;
  }
  p {
    @apply text-sm mb-3 text-justify;
  }
}
.sky__category-more-description {
  @apply text-sm pt-5 pb-0 px-3;
  h2 {
    @apply text-base font-bold my-1;
  }
  p {
    @apply mb-2 text-xs;
  }
}

</style>

<style lang="scss" scoped>
.sky__category-description-title {
  @apply text-3xl font-funny text-center px-5;
  @screen md {
    @apply text-5xl;
  }
}
</style>
